export default "__VITE_ASSET__b7afe54d__"